<template>
  <div>
    <!-- 健康证上传 -->
    <el-dialog :title="healthCertificateForm.type == 1 ? '健康证上传' : '技能证书上传'" :visible.sync="showHealthCertificateForm"
      width="600px" :close-on-click-modal="false" center>
      <el-form label-width="120px" :model="healthCertificateForm" ref="healthCertificateForm" :rules="rules">
        <el-form-item label="证件类型" prop="type">
          <el-select v-model="healthCertificateForm.type" placeholder="请选择类型" filterable>
            <el-option label="健康证" :value="1"></el-option>
            <el-option label="技能证书" :value="2"></el-option>
            <el-option label="花王认证" :value="3"></el-option>
            <el-option label="如逸认证" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件图片" prop="certificateFileUrl">
          <el-upload class="upload-demo" action="123" :limit="1" accept=".png, .jpg, jpeg" :file-list="fileListA"
            list-type="picture" :on-change="handleOnChangeA" :before-upload="beforeAvatarUploadA" :auto-upload="false">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        
        <el-form-item v-if="healthCertificateForm.type==1" label="体检机构名称" prop="certificateName">
          <el-input type="text" v-model="healthCertificateForm.certificateName" placeholder="请输入体检机构名称"
            clearable></el-input>
        </el-form-item>
        <el-form-item v-if="healthCertificateForm.type==2" label="技能证书名称" prop="certificateName">
          <el-input type="text" v-model="healthCertificateForm.certificateName" placeholder="请输入技能证书名称"
            clearable></el-input>
        </el-form-item>
        

        <el-form-item label="证件编号" prop="certificateNo">
          <el-input type="text" v-model="healthCertificateForm.certificateNo" placeholder="请输入证件编号" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="证件有效期" v-if="healthCertificateForm.type ==1||healthCertificateForm.type ==2" prop="expirationDate">
          <el-date-picker v-model="healthCertificateForm.expirationDate" style="width:100%" type="daterange"
            placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="发证时间" prop="issuanceDate">
          <el-date-picker v-model="healthCertificateForm.issuanceDate" type="date" placeholder="选择发证时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showHealthCertificateForm = false">关闭</el-button>
        <el-button type="primary" @click="saveHealthCertificate">保存</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";


export default {
  data() {
    return {
      addFile: service.addFile + globalData.userInfo.userAccount,
      showHealthCertificateForm: false,
      healthCertificateForm: {},
      fileListA: [],
      rules: {
        type: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur",
          },
        ],
        // certificateName: [
        //     {
        //         required: true,
        //         message: "请填写健康证名称",
        //         trigger: "blur",
        //     },
        // ],
        certificateNo: [
          {
            required: true,
            message: "请填写健康证编号",
            trigger: "change",
          },
        ],
        // expirationDateStart: [
        //     {
        //         required: true,
        //         message: "请选择有效期",
        //         trigger: "change",
        //     },
        // ],
        // expirationDate: [
        //     {
        //         required: true,
        //         message: "请选择有效期",
        //         trigger: "change",
        //     },
        // ],
        issuanceDate: [
          {
            required: true,
            message: "请选择发证时间",
            trigger: "change",
          },
        ],
      },
    };
  },

  methods: {
    handleHealth(id) {
      this.showHealthCertificateForm = true;
      this.healthCertificateForm = {
        operUserId: globalData.userInfo.id,
        operUserName: globalData.userInfo.userName,
        type: 1,
        workerSupperId: id,
      };
      this.fileListA = [];
    },
    saveHealthCertificate() {

      if (this.healthCertificateForm.workerSupperId == null) {
        this.$message.error("请选择服务者!");
        return;
      }
      if (this.healthCertificateForm.type  ==1||this.healthCertificateForm.type  ==2) {
        if (this.healthCertificateForm.type  ==1&&!this.healthCertificateForm.certificateName) {
          this.$message.error("请输入体检机构名称!");
          return;
        }
        if (this.healthCertificateForm.type  ==2&&!this.healthCertificateForm.certificateName) {
          this.$message.error("请输入技能证书名称!");
          return;
        }

        if (!this.healthCertificateForm.expirationDate) {
          this.$message.error("请选择有效期!");
          return;
        }
      } else {
        if (this.healthCertificateForm.type  ==3) {
          this.healthCertificateForm.certificateName = '花王认证'
        }
        if (this.healthCertificateForm.type  ==4) {
          this.healthCertificateForm.certificateName = '如逸认证'
        }
       
      }

      if (this.healthCertificateForm.certificateFileUrl) {
      } else {
        this.$message.error("请选择健康证并上传!");
        return;
      }
      console.info(this.healthCertificateForm);
      this.$refs["healthCertificateForm"].validate((valid) => {
        if (valid) {
          if (this.healthCertificateForm.type==1||this.healthCertificateForm.type==2) {
            this.healthCertificateForm.expirationDateStart =
              this.dateFormatYYYYMMDD(
                this.healthCertificateForm.expirationDate[0]
              );
            this.healthCertificateForm.expirationDateEnd =
              this.dateFormatYYYYMMDD(
                this.healthCertificateForm.expirationDate[1]
              );
          }
          this.healthCertificateForm.issuanceDate =
            this.dateFormatYYYYMMDD(
              this.healthCertificateForm.issuanceDate
            );
          workercrmapi
            .$axiosAddWorkerCertificate(this.healthCertificateForm)
            .then((res) => {
              this.$message.success("上传成功!");
              this.showHealthCertificateForm = false;
              this.$parent.getServantDetail();
            });
        }
      });
    },
    handleOnChangeA(file, fileListA) {
      if (file.raw) {
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        service.$ajaxAddFile(param).then((res) => {
          console.log(res);
          if (res.data.errno == 0) {
            this.healthCertificateForm.certificateFileUrl =
              res.data.data.fileUrl;
          }
        });
      }
    },
    beforeAvatarUploadA(file) {
      console.log("jianlai", file);
      const isJPG =
        file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/JEPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>
<style></style>
